import { render, staticRenderFns } from "./ModelSelect.vue?vue&type=template&id=3bc21bb9&scoped=true"
import script from "./ModelSelect.vue?vue&type=script&lang=ts"
export * from "./ModelSelect.vue?vue&type=script&lang=ts"
import style0 from "./ModelSelect.vue?vue&type=style&index=0&id=3bc21bb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc21bb9",
  null
  
)

export default component.exports